import template from './transacciones.html';
import { FormActions } from 'core/services/form';
import transaccionesI18NI18N from 'i18n/transacciones/es.json';
import { rest } from 'core/api';
import { fechaHoraRenderer } from 'core/util';

export let TransaccionesComponent = {
  templateUrl: template,
  selector: 'transacciones',
  bindings: {
    translations: '='
  },
  controller: TransaccionesCtrl,
  controllerAs: 'vm'
};

const commonsI18N = [
  'Elemento borrado correctamente'
];
export const translationKeys = Object.keys(transaccionesI18NI18N).concat(commonsI18N);

TransaccionesCtrl.$inject = [
  'BasicFactory', '$ngRedux', '$state', '$stateParams', 'ngNotify', 'Filter', 'AuthorizationService'
];

function TransaccionesCtrl(BasicFactory, $ngRedux, $state, $stateParams, ngNotify, Filter,
  AuthorizationService) {

  Object.assign(this, { $state, $ngRedux, ngNotify });

  var defaultColumnOrder = ['descripcion', 'factura.numeroComprobante', 'fecha', 'tipoTransaccion.value', 'estado.value'];
  BasicFactory.setup('transacciones');

  const estadoQuery = Filter.path('tipo.codigo').eq('estado_transaccion');
  const estadoUrl = encodeURI('valores?filter=' + JSON.stringify(estadoQuery));

  const tipoQuery = Filter.path('tipo.codigo').eq('tipo_transaccion');
  const tipoUrl = encodeURI('valores?filter=' + JSON.stringify(tipoQuery));

  var staticFilter = Filter.path('caja.id').eq($stateParams.eid);
  var sesionCajaFilter = Filter.path('id').eq($stateParams.eid);
  this.localModel = {};

  this.sesionCajaActual = () => {
    const sesion = this.localModel.sesionCaja;
    return sesion ? `#${sesion.id}, ${sesion.caja.nombre} - Estado: ${sesion.estado.value} - Abierta: ${fechaHoraRenderer(sesion.fechaInicio)}` +  (sesion.fechaCierre ? `- Cerrada: ${fechaHoraRenderer(sesion.fechaCierre)}` : '') : '';
  }

  this.options = {
    staticFilter,
    resource: 'transacciones',
    hideHeader: true,
    hasOptions: true,
    title: this.translations['Listado de transacciones de sesion de caja'],
    factory: BasicFactory,
    defaultColumnOrder: defaultColumnOrder,
    columns: [
      { data: 'id', title: 'Id' },
      { data: 'descripcion', title: this.translations['Descripción'] },
      { data: 'fecha', title: this.translations['Fecha'], type: 'date-range' },
      { data: 'fechaRectificacion', title: this.translations['Fecha Rectificacion'], type: 'date-range' },
      {
        data: 'factura.numeroComprobante',
        title: this.translations['Nro. Factura'],
        render: function(data, type, row) {
          return row.factura ? row.factura.numeroComprobante : '<i>Sin Factura</i>';
        }
      },
      {
        data: 'usuarioRectificacion.nombre',
        title: this.translations['Usuario Rectificacion'],
        render: function(data, type, row) {
          var str = '';
          if (row.usuarioRectificacion) {
            if (row.usuarioRectificacion.nombre !== undefined) {
              str = str + row.usuarioRectificacion.nombre;
            }
            if (row.usuarioRectificacion.apellido !== undefined) {
              str = str + ' ' + row.usuarioRectificacion.apellido;
            }
          }
          return str != '' ? str : '<i>No establecido</i>';
        }
      },
      {
        data: 'cajero.nombre',
        title: this.translations['Cajero'],
        render: function(data, type, row) {
          var str = '';
          if (row.cajero) {
            if (row.cajero.nombre !== undefined) {
              str = str + row.cajero.nombre;
            }
            if (row.cajero.apellido !== undefined) {
              str = str + ' ' + row.cajero.apellido;
            }
          }
          return str != '' ? str : '<i>No establecido</i>';
        }
      },
      {
        data: 'tipoTransaccion.value',
        title: this.translations['Tipo'],
        type: 'combo',
        filterUrl: tipoUrl,
        idField: 'value',
        textField: 'name',
        keyData: 'data',
        render: function(data, type, row) {
          return row.tipoTransaccion ? row.tipoTransaccion.name : '<i>No establecido</i>';
        }
      },
      {
        data: 'estado.value',
        title: this.translations['Estado'],
        type: 'combo',
        filterUrl: estadoUrl,
        idField: 'value',
        textField: 'name',
        keyData: 'data',
        render: function(data, type, row) {
          return row.estado ? row.estado.name : '<i>No establecido</i>';
        }
      }
    ],
    defaultOrderColumn: 0,
    defaultOrderDir: 'desc',
    onEdit: onEdit.bind(this),
    onView: onView.bind(this),
    canEditCondition: canEdit.bind(this),
    canRemoveCondition: () => false
  };

  function canEdit(data) {
    return data.factura && data.estado.value === 'Procesada' && AuthorizationService.hasPermission('update_cajas');
  }

  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);

  const unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  this.$onInit = () => {
    this.reportOptions = {
      title: this.translations['Listado de transacciones']
    };
    this.form();
    $ngRedux.dispatch(rest.actions.allSesionesCaja({ filter: JSON.stringify(sesionCajaFilter) }));

  };

  function mapStateToThis(state) {
    this.handleStatus(state);

    if (state.allSesionesCaja.data && state.allSesionesCaja.data.length > 0 && !this.localModel.sesionCaja) {
      this.localModel.sesionCaja = state.allSesionesCaja.data[0];
    }

    return { form: state.form };
  }

  function handleStatus(state) {
    if (state.form.removed) {
      ngNotify.set(this.translations['Elemento borrado correctamente'], 'success');
      this.options.reloadData();
      this.form();
    }
    if (state.form.error) {
      ngNotify.set(state.form.error.message, 'error');
    }
  }

  function onEdit(itemId) {
    $state.go('home.cajas.uid.sesiones-cajas.eid.transacciones.tid.edit', { uid:  $stateParams.uid, eid: $stateParams.eid, tid: itemId});
  }

  function onView(itemId) {
    $state.go('home.cajas.uid.sesiones-cajas.eid.transacciones.tid.view', { uid:  $stateParams.uid, eid: $stateParams.eid, tid: itemId});
  }
}


// WEBPACK FOOTER //
// ./src/components/cajas/sesiones-cajas/transacciones/list/transacciones.component.js